<template>
  <v-checkbox
    :label="`I have a valid driver's license`"
    v-model="profile.driversLicense"
    @change="submit"
    :color="themes.candidate.light.input"
  />
</template>

<script>
// Vue Component
export default {
  props: ['value'],
  data() {
    return {
      // Model (object sent to API)
      profile: {
        driversLicense: this.value
      }
    }
  },
  methods: {
    submit() {
      this.$store.dispatch('candidate/profile/update', this.profile)
    }
  }
}
</script>
